import { useQuery } from '@tanstack/react-query';
import type { PromptAnalysisUsageResponse } from '@brand24-original/llm-types';
import { getPromptAnalysisUsage } from '../../services/prompt-analysis/PromptAnalysisService';
import { GET_PROMPT_ANALYSIS_USAGE } from '../../query/prompt-analysis/keys';

/** Monthly quota for the whole account — no projectId in the key, shared across projects. */
export const useGetPromptAnalysisUsage = (enabled: boolean) =>
  useQuery<PromptAnalysisUsageResponse>({
    queryKey: [GET_PROMPT_ANALYSIS_USAGE],
    queryFn: getPromptAnalysisUsage,
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
